module.exports = __webpack_public_path__ + "img/locked-icon.e94ec7b3.svg";